/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Indemnification_Item_4Inputs */

const es_tyc_indemnification_item_4 = /** @type {(inputs: Tyc_Indemnification_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alegaciones de que su uso del Servicio provoco una infraccion de derechos de propiedad intelectual de terceros.`)
};

const en_tyc_indemnification_item_4 = /** @type {(inputs: Tyc_Indemnification_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allegations that your use of the Service caused an infringement of third-party intellectual property rights.`)
};

/**
* | output |
* | --- |
* | "Allegations that your use of the Service caused an infringement of third-party intellectual property rights." |
*
* @param {Tyc_Indemnification_Item_4Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_indemnification_item_4 = /** @type {((inputs?: Tyc_Indemnification_Item_4Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Indemnification_Item_4Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_indemnification_item_4(inputs)
	return en_tyc_indemnification_item_4(inputs)
});
export { tyc_indemnification_item_4 as "tyc.indemnification.item_4" }